module.exports = __webpack_public_path__ + "img/Icon_ArrowCircle.5f811c84.svg";